import useOnlineStatus from '@rehooks/online-status';
import MultiField from 'Components/Forms/MultiField';
import { useEffect, useState } from 'react';
import api from 'Services/api';
import valueStore from 'Services/valueStore';

const EquipmentList = ({ equipment, push, remove, required = false, ...props }) => {
  const isOnline = useOnlineStatus();
  const [suggestions, setSuggestions] = useState([]);

  const sync = () => {
    const getEquipment = async () => await api.fetchEquipment();

    getEquipment().then(async (equipmentList) => {
      const values = equipmentList.map((item) => item.description);
      setSuggestions(values);
      await valueStore.set(`equipment`, values);
    });
  };

  useEffect(() => {
    const loadEquipment = async () => {
      if (isOnline) {
        sync();
      } else {
        const storedEquipment = await valueStore.getArray(`equipment`);
        setSuggestions(storedEquipment || []);
      }
    };

    loadEquipment();
  }, [isOnline]);

  return (
    <MultiField
      name="equipment"
      values={equipment}
      push={push}
      remove={remove}
      label="What equipment will be used?"
      placeholder="Add new equipment"
      required={required}
      suggestions={suggestions}
      isSortable={false}
      valueKey="description"
    />
  );
};

export default EquipmentList;
